import React from "react";
import { PageSettings } from "./config/page-settings.js";
import Content from "./components/content/content.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingOverlay from "react-loading-overlay";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import {
	updateLoginUser,
	resetLogin,
	performLogout,
	heartBeat,
	handleHeartbeatResponse,
	triggerParallelLoginRedirect
} from "./redux/AuthAction.js";
import { 
	setAppSetting,
	setDepositModal,
	setDownlineModal,
	setShareReferralModal,
	setGameLobbyModal,
	setMyProfileModal,
	setSpinWheelListModal,
	setSpinWheelReportModal,
	setReportOverviewModal,
	setGameIframeModal,
	setCompleteInfoModal,
	setRegisterSuccessModal,
	setShowAnnouncementModal,
	setDailyCheckinModal,
	setReferralBonusModal,
	setMusicPlayerModal,
	armModalInitGate,
 } from "./redux/AppAction.js";
import { isObjectEmpty, stringIsNullOrEmpty, createFormBody, isValidLocale, hasValidLocale, extractLocaleFromPathname, waitForFbPixel } from "./util/Util.js";
import { injectReferralGtm, lookupGtmId, resolveReferralCode } from "./components/GoogleTag/ReferralGtm.js";
import { withTranslation } from "react-i18next";
import ApiEngine from "./util/ApiEngine.js";
import { ApiKey, ApiUrl, HIDE_APK_BANNER_DURATION, SessionKey, WebUrl } from "./util/Constant";
// Schema-driven UI system - replaces template-based theming
import SchemaLoader from "./theme-system/SchemaLoader";
import ThemePreviewBar from "./theme-system/ThemePreviewBar.jsx";
// import { themeGenerator } from "config/theme.js";
// import { paramCase } from "change-case";
import { ClientTemplates } from "./util/Constant";
import { Helmet } from "react-helmet";
import { Spinner } from "react-bootstrap";
import classNames from "classnames";
import { getSeoKeywords, getSeoKeywordsAsync } from "./util/SeoUtil.js";
import { setBusy, setIdle } from "./redux/AppAction";
import { saveLanguageId } from "./redux/LanguageAction.js";
import { showGameLaunchError } from "./util/gameLaunchError";

import { logConsoleErrorToLocalStorage, mergeAndFlushClientErrorLogs } from "./util/ClientLogger.js";
import {
	getPlayerCountersFromSettings,
	isPlayerCounterEnabled,
	normalizePlayerCounterSettings
} from "./util/PlayerCounterUtil.js";
import { readFakeTransactionCache } from "./util/FakeTransactionUtil.js";
import PromoExpiryPoll from "./components/custom/PromoExpiryPoll";
import { shouldRestoreProviderListScroll } from "./util/providerListBackNavUtil.js";
// import { map } from "lodash";
// import parse from "html-react-parser";

LoadingOverlay.propTypes = undefined;
class App extends React.Component {
	constructor(props) {
		super(props);
		this.initialPathname = window.location.pathname;
		// A route change may cause several renders before the first SEO response
		// reaches session storage. Share that request instead of issuing one per render.
		this.seoMetaRequests = new Map();

		this.handleSetPageContent = (value) => {
			this.setState((state) => ({
				pageContent: value,
			}));
		};
		this.handleSetPageContentClass = (value) => {
			this.setState((state) => ({
				pageContentClass: value,
			}));
		};
		this.handleSetPageContentFullHeight = (value) => {
			this.setState((state) => ({
				pageContentFullHeight: value,
			}));
		};
		this.handleSetPageContentFullWidth = (value) => {
			this.setState((state) => ({
				pageContentFullWidth: value,
			}));
		};
		this.handleSetPageContentInverseMode = (value) => {
			this.setState((state) => ({
				pageContentInverseMode: value,
			}));
		};
		this.handleSetPageFooter = (value) => {
			this.setState((state) => ({
				pageFooter: value,
			}));
		};
		this.handleSetBodyWhiteBg = (value) => {
			if (value === true) {
				document.body.classList.add("bg-white");
			} else {
				document.body.classList.remove("bg-white");
			}
		};
		
		this.state = {
			pageContent: true,
			pageContentClass: "",
			pageContentFullHeight: false,
			pageContentFullWidth: true,
			pageContentInverseMode: false,
			pageNavBar: "",
			handleSetPageContent: this.handleSetPageContent,
			handleSetPageContentClass: this.handleSetPageContentClass,
			handleSetPageContentFullHeight: this.handleSetPageContentFullHeight,
			handleSetPageContentFullWidth: this.handleSetPageContentFullWidth,
			handleSetPageContentInverseMode: this.handleSetPageContentInverseMode,

			pageFooter: false,
			handleSetPageFooter: this.handleSetPageFooter,
			error: null,
			errorInfo: null,

			handleSetBodyWhiteBg: this.handleSetBodyWhiteBg,
			handleSetPageBoxedLayout: this.handleSetPageBoxedLayout,

			interval1: null,
			location: window.location.href,
			language: this.props.i18n.language,
			appLoad: true,
			showSeoH1: true,
		};

		this.scrollRef = React.createRef();
	}

	channel = null;
	heartbeatInterval = null;
	isHeartbeatLeader = false;
	lastPing = 0;
	heartbeatInFlight = false;
	tabId = Math.random().toString(36).slice(2);

	tempRecordChannel = null;
	tempRecordInterval = null;
	isTempRecordLeader = false;
	tempRecordLastPing = 0;
	tempRecordInFlight = false;

	// Function as a go-between mapping for webcache and old settings response
	normalizeSettings = (apiData) => {
		if (!apiData) {
			return {
				useWebCache: false,
				version: "",
				rawEntries: [],
				data: {},
			};
		}

		// NEW WebCache response
		if (apiData.useWebCache === true) {
			return {
				useWebCache: true,
				version: apiData.version || "",
				rawEntries: apiData.rawEntries || [],
				data: apiData.data || {},
			};
		}

		// OLD WebSetting response
		return {
			useWebCache: false,
			version: "",
			rawEntries: [],
			data: apiData,
		};
	};

	/// <summary>
	/// Author: -
	/// </summary>
	async componentDidMount() {
		// Initialize global error logger - this will log to localStorage
		// (Console: latest 2 hour, max 200; API: max 20 failed responses)
		window.addEventListener("error", this.handleGlobalError);
  		window.addEventListener("unhandledrejection", this.handlePromiseRejection);
		this._onGameLaunchError = (event) => {
			if (event.origin !== window.location.origin) return;
			const data = event.data;
			if (!data || data.type !== "game-launch-error" || typeof data.key !== "string") return;
			showGameLaunchError(data.key);
		};
		window.addEventListener("message", this._onGameLaunchError);
		//console.log("%c[LOGGER] Global error listeners initialized", 'background: blue;');

		// page-* via classList (not Helmet body className) so modal-open / theme classes survive
		this.syncBodyPageClass();
		// Hold orchestrated modals for MODAL_INIT_DELAY_MS after page init
		armModalInitGate();

		// DEBUG: Expose flush function for console debugging
        window.debugFlush = () => {
			for (const key of Object.keys(localStorage)) {
				if (key.startsWith("client_error_logs_")) {
					const logsRaw = localStorage.getItem(key);
					const logs = logsRaw ? JSON.parse(logsRaw) : [];
					//console.log(key, logs);
				}
			}
            mergeAndFlushClientErrorLogs();
			for (const key of Object.keys(localStorage)) {
				if (key.startsWith("client_error_logs_")) {
					const logsRaw = localStorage.getItem(key);
					const logs = logsRaw ? JSON.parse(logsRaw) : [];
					//console.log(key, logs);
				}
			}
        };

		// One tab is the leader. It sends heartbeat and UpdateTempRecord.
		// Other tabs stay quiet until that leader goes away.
		this.setupHeartbeatBroadcastChannel();
		this.setupUpdateTempRecordBroadcastChannel();

		// clearInterval(this.state.interval1);
		// this.state.interval1 = null;
		// this.props.heartBeat();
		// this.state.interval1 = setInterval(() => this.props.heartBeat(), 20000);

		//for color picker demo

		// Keep <style id="custom-style"> permanently as the last stylesheet in
		// <head>. style-loader injects new <style> tags whenever React components
		// mount, pushing custom-style earlier in the cascade and overriding it.
		// The MutationObserver moves custom-style back to the end on every head
		// mutation so it always wins — without touching other elements.
		//
		// Stored on `this` so componentWillUnmount can disconnect it and prevent
		// a memory leak. Guard against double-registration on HMR remounts.
		if (this._customStyleObserver) this._customStyleObserver.disconnect();
		this._customStyleObserver = new MutationObserver(() => {
			const el = document.getElementById("custom-style");
			if (el && el !== document.head.lastElementChild) {
				document.head.appendChild(el);
			}
		});
		this._customStyleObserver.observe(document.head, { childList: true });

		window.addEventListener("message", (event) => {
			// Update CSS variable
			const { variable, value } = event.data;
			if (event.data?.type === "updateVariable") {
				document.documentElement.style.setProperty(variable, value);
			}

			// Update Custom CSS
			if (event.data?.type === "updateCustomCss") {
				let tag = document.getElementById("__customCss__");
				if (!tag) {
					tag = document.createElement("style");
					tag.id = "__customCss__";
					document.head.appendChild(tag);
				}
				tag.textContent = event.data.css;
			}
		});


		document.addEventListener("click", function (e) {
			const el = e.target.closest("[data-theme-key]");
			if (!el) return;

			const themeKey = el.getAttribute("data-theme-key");

			window.parent.postMessage(
				{
				type: "elementClicked",
				element: themeKey,
				},
				"*"
			);
		});

		const savedLang =
			localStorage.getItem("userSelectedLanguageCode") ||
			localStorage.getItem(SessionKey._LANGUAGE);
		if (savedLang) {
			await this.props.i18n.changeLanguage(savedLang);
			await this.props.saveLanguageId(savedLang);
		} else {
			await this.initDefaultLanguage();
		}

		const tg = window.Telegram?.WebApp;

		if (tg) {

			try {
				tg.ready();
				tg.expand();

				const user = tg.initDataUnsafe?.user;
				const urlParams = new URLSearchParams(window.location.search);
				const botId = urlParams.get("botId");
				const selectedLanguageCode =
					urlParams.get("lang") || localStorage.getItem("userSelectedLanguageCode");

				if (user) {
					this.props.setBusy();
					this.props.performLogout();
					await fetch(`/api/telegram/miniapp-callback`, {
						method: "POST",
						headers: { "Content-Type": "application/json",
									"ngrok-skip-browser-warning": "true" },
						body: JSON.stringify({
							initData: tg.initData,
							user: tg.initDataUnsafe?.user,
							botId: botId,
							selectedLanguageCode: selectedLanguageCode
						}),
					})
					.then((res) => res.json())
					.then((data) => {
						if (data.success && data.data) {
							var userData = data.data["userData"];
							if (window.ReactNativeWebView) {
							window.ReactNativeWebView.postMessage(
								JSON.stringify({
								action: "login",
								jwtToken: data.data["jwtToken"],
								userId: userData["userId"]
								})
							);
							window.ReactNativeWebView.postMessage(
								JSON.stringify({
								action: "change-theme",
								themeId: userData["selectedTheme"],
								})
							);
							}
									
							this.props.updateLoginUser(userData);

							localStorage.setItem(SessionKey._ISSHOWMINIGAMETRIGGER, true);
						}
						this.props.setIdle();
					})
					.catch((err) => { this.props.setIdle(); console.error("Telegram auth error:", err) });
				}
			} catch (err) {
				console.error("Telegram Mini App init failed:", err);
			this.props.setIdle();
			}
				
		}


		this.setState({
			// hasGetSkinSettings: false,
			hasCustomSkin: false,
			activeTheme: 0,
			backgroundImage: "",
		});

		// // Dynamically import the CSS file based on the environment variable
		// const root = process.env.REACT_APP_ROOT ? process.env.REACT_APP_ROOT : 'rootbase';

		this.setState({ appLoad: true });
		try {
			await import(`./assets/css/rootbase.css`);
			// console.log(`${root}.css loaded successfully!`);
		} catch (error) {
			// console.log(`Failed to load ${root}.css`, error);
		} finally {
			this.setState({ appLoad: false });
		}

		await this.fetchSettings();
		this.getMeta(this.props.i18n.language);
		this.getBrandSeoSchema();

		// Create a custom event
		const customEvent = new CustomEvent('changedLocation', {
			detail: { message: `Location changed to ${window.location.pathname}` }
		});

		// Dispatch the event
		window.dispatchEvent(customEvent);

		// Ensure there is always at least one <h1> for SEO/a11y audits (hide ours if page already provides one)
		setTimeout(this.refreshSeoH1Visibility, 0);
	}

	componentDidUpdate(prevProps, prevState) {
		// // CHRIS DEBUG
		// // Console log a styled note
		// console.log(
		// 	"%ccomponentDidUpdate",
		// 	"background: #222; color: #bada55"
		// );

		// // CHRIS DEBUG
		// // Compare props
		// const allPropsKeys = Object.keys({ ...prevProps, ...this.props });
		// allPropsKeys.forEach(key => {
		//   if (prevProps[key] !== this.props[key]) {
		// 	console.log(`Prop '${key}' changed:`, prevProps[key], '->', this.props[key]);
		//   }
		// });

		// // CHRIS DEBUG
		// // Compare state
		// const allStateKeys = Object.keys({ ...prevState, ...this.state });
		// allStateKeys.forEach(key => {
		//   if (prevState[key] !== this.state[key]) {
		// 	console.log(`State '${key}' changed:`, prevState[key], '->', this.state[key]);
		//   }
		// });

		// once the flag flips true, push to home and reset everything
		if (!prevProps.authState.triggerParallelLoginRedirect && this.props.authState.triggerParallelLoginRedirect) {
			this.props.history.push('/');
			this.props.triggerParallelLoginRedirect(false);

			// Close all popups
			this.props.setDepositModal(false);
			this.props.setDownlineModal(false);
			this.props.setShareReferralModal(false);
			this.props.setGameLobbyModal(false);
			this.props.setMyProfileModal(false);
			this.props.setSpinWheelListModal(false);
			this.props.setSpinWheelReportModal(false);
			this.props.setReportOverviewModal(false);
			this.props.setGameIframeModal(false);
			this.props.setCompleteInfoModal(false);
			this.props.setDailyCheckinModal(false);
			this.props.setReferralBonusModal(false);
			this.props.setMusicPlayerModal(false);
			this.props.setRegisterSuccessModal(false);
			this.props.setShowAnnouncementModal(false);
		}


		if (
			this.props.languageState.languageId != prevProps.languageState.languageId
		) {
			this.props.i18n.changeLanguage(this.props.languageState.languageId);
		}

		// if (!this.state.hasCustomSkin) {
		// 	let heartBeat = this.props.authState.heartBeat;
		// 	if (heartBeat) {
		// 		this.getSkinSettings();
		// 	}
		// }

		if (
			this.state.location !== window.location.href ||
			this.props.i18n.language !== prevProps.i18n.language
		) {
			// console.log("%c componentDidUpdate getSetting", "background: #222; color:rgb(218, 85, 85)");
			// CHRIS TODO 20250306: Instead of calling this.getSetting() every page change, we should use a caching method with 5 min expiry for active tabs
			// ie. if tab active - check expiry of settings every 5 min, if tab not active, pause checking
			// If no differences, do not update redux
			this.getSetting(this.props.i18n.language);
			this.getMeta(this.props.i18n.language);
			this.setState({
				location: window.location.href,
				language: this.props.i18n.language,
			});

			this.syncBodyPageClass();

			const locationState = this.props.history?.location?.state;
			const preserveProviderListScroll =
				shouldRestoreProviderListScroll(locationState);

			if (!preserveProviderListScroll) {
				// this.scrollRef.current.scrollTop = 0;
				if (this.scrollRef && this.scrollRef.current) {
					this.scrollRef.current.scrollTop = 0;
				}

				window.scrollTo(0, 0);
			}

			// Create a custom event
			const customEvent = new CustomEvent('changedLocation', {
				detail: { message: `Location changed to ${window.location.pathname}` }
			});

			// Dispatch the event
			window.dispatchEvent(customEvent);

			// Re-check on route change (some pages may render their own <h1>)
			setTimeout(this.refreshSeoH1Visibility, 0);
		}


		if (
			this.state.seoTitle != this.props.appState.seoContent?.seoTitle
			|| this.state.seoDescription != this.props.appState.seoContent?.seoDescription
			|| this.state.seoImage != this.props.appState.seoContent?.seoImage
			|| this.state.seoKeywords != this.props.appState.seoContent?.seoKeywords
		) {
			this.setState({
				seoTitle: this.props.appState.seoContent.seoTitle,
				seoDescription: this.props.appState.seoContent.seoDescription,
				seoImage: this.props.appState.seoContent.seoImage,
				seoKeywords: this.props.appState.seoContent.seoKeywords
			});
		}
	}

	getSeoH1Text() {
		// Prefer explicit page name/title, then SEO title, then site title/brand
		let text = this.state.brandName || "";
		
		// Extract page title from URL
		try {
			const pageSlug = this.getPageSlug(window.location.pathname);
			
			// Check if it's home page (/en/ or /)
			if (pageSlug === '/' || pageSlug === '') {
				return text + " Home";
			}
			
			// Remove leading slash and get the last segment
			const segments = pageSlug.split('/').filter(segment => segment.length > 0);
			
			if (segments.length > 0) {
				// Get the last segment (page name)
				const pageName = segments[segments.length - 1];
				// Convert hyphens to spaces and title case
				const pageTitle = pageName
					.split('-')
					.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
					.join(' ');
				
				// Append page title to brand name
				if (pageTitle) {
					text = text ? `${text} ${pageTitle}` : pageTitle;
				}
			}
		} catch (e) {
			// If extraction fails, just use brand name
		}
		
		// Keep it single-line and non-empty
		try {
			const cleaned = String(text).replace(/\s+/g, " ").trim();
			return cleaned.length ? cleaned : "Home";
		} catch (e) {
			return  text + " Home";
		}
	}

	refreshSeoH1Visibility = () => {
		try {
			// Let the current route component render first, then inspect DOM.
			window.requestAnimationFrame(() => {
				const h1Elements = Array.from(document.querySelectorAll("h1"));
				const hasOtherH1 = h1Elements.some(
					(el) => el && el.id !== "seo-h1" && (el.textContent || "").trim().length > 0
				);
				const nextShow = !hasOtherH1;
				if (this.state.showSeoH1 !== nextShow) {
					this.setState({ showSeoH1: nextShow });
				}
			});
		} catch (e) {
			// If DOM inspection fails for any reason, keep our <h1> visible in markup.
			if (this.state.showSeoH1 !== true) this.setState({ showSeoH1: true });
		}
	};

	// CHRIS 20240801: Not used for some reason
	// applyTheme() {
	// 	if (this.state.template == "template_1") {
	// 		const themeValue = themeGenerator("template1");

	// 		for (const [key, value] of Object.entries(themeValue)) {
	// 			const variableName = `--${paramCase(key)}`;
	// 			document.documentElement.style.setProperty(variableName, value);
	// 		}
	// 	}
	// }

	/// <summary>
	/// Author: -
	/// </summary>
	async componentDidCatch(error, errorInfo) {
		this.setState({
			error: error,
			errorInfo: errorInfo,
		});

		// Send to backend via shared logClientError
		try {
			await this.logClientError("react.errorboundary", {
				message: error?.message || "Unknown React render error",
				stack: error?.stack || null,
				componentStack: errorInfo?.componentStack || null,
			});
		} catch (err) {
			console.warn("Failed to log React error boundary:", err);
		}
	}

	setupHeartbeatBroadcastChannel = () => {
		try {
			if (!window.BroadcastChannel) {
				//console.warn("BroadcastChannel not supported. Heartbeat sync may not work across tabs.");
			}

			this.channel = new BroadcastChannel("heartbeat-channel");

			this.channel.onmessage = (event) => {
				if (event.data.type === "heartbeat-ping" && event.data.tabId !== this.tabId) {
					this.lastPing = Date.now();
					if (this.isHeartbeatLeader && event.data.tabId < this.tabId) {
						this.isHeartbeatLeader = false;
					}
				}

				if (event.data.type === "heartbeat-data") {

					this.handleHeartbeatData(event.data.payload);
				}
			};

			// First tab to wake up becomes the only caller. A later ping from a
			// lower tabId wins if two tabs claim in the same moment.
			const claimDelay = 200 + Math.floor(Math.random() * 800);
			this.heartbeatClaimTimer = setTimeout(() => {
				if (Date.now() - this.lastPing < 25000) return;
				this.isHeartbeatLeader = true;
				this.channel.postMessage({ type: "heartbeat-ping", tabId: this.tabId });
				this.sendHeartbeat();
			}, claimDelay);

			const heartbeatLoop = async () => {
				if (this.heartbeatStopped) return;
				const now = Date.now();

				if (!this.isHeartbeatLeader && now - this.lastPing > 25000) {
					this.isHeartbeatLeader = true;
				}

				if (this.isHeartbeatLeader) {
					this.channel.postMessage({ type: "heartbeat-ping", tabId: this.tabId });
					await this.sendHeartbeat();
				}

				if (this.heartbeatStopped) return;
				this.heartbeatInterval = setTimeout(heartbeatLoop, 10000);
			};
			this.heartbeatInterval = setTimeout(heartbeatLoop, 10000);

			window.addEventListener("beforeunload", () => {
				try {
					if (this.isHeartbeatLeader) this.isHeartbeatLeader = false;
				} catch (error) {
					console.error("Error handling beforeunload event:", error);
				}
			});
		} catch (error) {
			console.error("Error setting up heartbeat broadcast channel:", error);
		}
	};

	sendHeartbeat = async () => {
		if (!this.isHeartbeatLeader || this.heartbeatInFlight) return;
		const run = async () => {
			this.heartbeatInFlight = true;
			try {
				var responseJson = await ApiEngine.get(ApiUrl._API_IS_LOGGED_IN); //, createMultiPartFormBody(params));

				const data = {
					responseJson: responseJson,
				}

				this.channel.postMessage({
					type: "heartbeat-data",
					payload: data,
				});

				this.handleHeartbeatData(data);
			} catch (err) {
				//console.warn("Heartbeat failed", err);
			} finally {
				this.heartbeatInFlight = false;
			}
		};

		// Held until the request finishes, including while this tab is paused on a breakpoint.
		if (navigator.locks) {
			await navigator.locks.request("member-heartbeat", { ifAvailable: true }, async (lock) => {
				if (!lock) return;
				await run();
			});
			return;
		}
		await run();
	};

	handleHeartbeatData = (data) => {
		if (data.responseJson) {
			// Update redux
			try {
				this.props.handleHeartbeatResponse(data.responseJson);
			} catch (e) {
				//console.error("Error in handleHeartbeatResponse:", e);
			}
		}
	};


	setupUpdateTempRecordBroadcastChannel = () => {
		try {
			if (!window.BroadcastChannel) {
				// BroadcastChannel not supported
			}

			this.tempRecordChannel = new BroadcastChannel("temprecord-channel");

			this.tempRecordChannel.onmessage = (event) => {
				if (event.data.type === "temprecord-ping" && event.data.tabId !== this.tabId) {
					this.tempRecordLastPing = Date.now();
					if (this.isTempRecordLeader && event.data.tabId < this.tabId) {
						this.isTempRecordLeader = false;
					}
				}
				if (event.data.type === "temprecord-data") {
					// handle the received temp record data if needed
				}
			};

			this.tempRecordLastPing = 0;
			this.tempRecordIsWaiting = false;

			const claimDelay = 200 + Math.floor(Math.random() * 800);
			this.tempRecordClaimTimer = setTimeout(() => {
				if (Date.now() - this.tempRecordLastPing < 25000) return;
				this.isTempRecordLeader = true;
				this.tempRecordChannel.postMessage({ type: "temprecord-ping", tabId: this.tabId });
				this.sendUpdateTempRecord();
			}, claimDelay);

			const nextInterval = async () => {
				if (this.tempRecordStopped) return;
				const now = Date.now();

				if (!this.isTempRecordLeader && now - this.tempRecordLastPing > 25000) {
					this.isTempRecordLeader = true;
				}

				if (this.isTempRecordLeader) {
					this.tempRecordChannel.postMessage({ type: "temprecord-ping", tabId: this.tabId });
					await this.sendUpdateTempRecord();
				}

				if (this.tempRecordStopped) return;
				this.tempRecordInterval = setTimeout(nextInterval, 10000);
			};
			this.tempRecordInterval = setTimeout(nextInterval, 10000);

			window.addEventListener("beforeunload", () => {
				try {
					if (this.isTempRecordLeader) this.isTempRecordLeader = false;
				} catch (error) {
					console.error("Error handling beforeunload event:", error);
				}
			});
		} catch (error) {
			console.error("Error setting up tempRecord broadcast channel:", error);
		}
	};

	sendUpdateTempRecord = async () => {
		if (!this.isTempRecordLeader || this.tempRecordInFlight) return;
		const run = async () => {
			this.tempRecordInFlight = true;
			try {
				var responseJson = await ApiEngine.get(ApiUrl._API_UPDATE_TEMP_WALLET);

				const data = {
					responseJson: responseJson,
				};

				this.tempRecordChannel.postMessage({
					type: "temprecord-data",
					payload: data,
				});

			} catch (err) {
				// Ignore errors
			} finally {
				this.tempRecordInFlight = false;
			}
		};

		if (navigator.locks) {
			await navigator.locks.request("member-temp-record", { ifAvailable: true }, async (lock) => {
				if (!lock) return;
				await run();
			});
			return;
		}
		await run();
	};

	// ==============================
	// JS Error Logging - START
	// ==============================
	errorQueue = [];
	flushTimeout = null;
	batchSize = 20;     // flush when queue reaches 20
	batchDelay = 3000;  // flush after 3 seconds

	handleGlobalError = async (event) => {
		//console.log("%c[LOGGER] Detected global error:", 'background: blue;', event);
		try {
			await this.logClientError("window.onerror", {
				message: event?.message || "Unknown error",
				filename: event?.filename,
				lineno: event?.lineno,
				colno: event?.colno,
				stack: event?.error?.stack || null,
				outerHTML: event.srcElement?.outerHTML, // if a DOM element caused it
			});
		} catch (err) {
			console.warn("Failed to log global error", err);
		}
	};

	handlePromiseRejection = async (event) => {
		//console.log("%c[LOGGER] Detected unhandledrejection:", 'background: blue;', event);
		try {
			await this.logClientError("unhandledrejection", {
				message:
					(event?.reason && event.reason.message) ||
					String(event.reason) ||
					"Unhandled promise rejection",
				stack: event?.reason?.stack || null,
			});
		} catch (err) {
			console.warn("Failed to log unhandled rejection", err);
		}
	};

	async logClientError(source, data = {}) {
		// Log locally (for dev)
		//console.log("%c[LOGGER] logClientError react render error:", 'background: blue;', source, data);

		try {
			const payload = {
				source,
				errorHash: await this.generateErrorHash(data),
				url: window.location.href,
				timestamp: new Date().toISOString(),
				userAgent: navigator.userAgent,
				os: this.getOS(),
				browser: this.getBrowser(),
        		screenResolution: `${window.innerWidth}x${window.innerHeight}`,
				appVersion: process.env.REACT_APP_VERSION || 'unknown',
				// rawPayloadJson: JSON.stringify(data),
				// Do this at the BE side
				// username: currentUser?.username || null,
				// companyId: currentCompany?.id || null,
				...data,
			};

			// Push to localStorage
			await logConsoleErrorToLocalStorage(payload);

			// // Push to queue
			// this.errorQueue.push(payload);

			// // Flush immediately if batch size reached
			// if (this.errorQueue.length >= this.batchSize) {
			// 	this.flushErrors();
			// 	return;
			// }

			// // Schedule flush if not already scheduled
			// if (!this.flushTimeout) {
			// 	this.flushTimeout = setTimeout(() => this.flushErrors(), this.batchDelay);
			// }
		} catch (err) {
			console.warn("Failed to log JS error:", err);
		}
	}

	async generateErrorHash(payload) {
		// const str = `${payload.message}|${payload.stack || ''}|${payload.filename || ''}|${payload.lineno || ''}|${payload.colno || ''}|${payload.url || ''}|${payload.source || ''}`;

		const appVersion = process.env.REACT_APP_VERSION || 'unknown';
		const str = [
			payload.message?.trim(),
			(payload.stack || '').trim(),
			payload.filename?.trim(),
			payload.lineno || '',
			payload.colno || '',
			payload.url?.trim(),
			payload.source?.trim(),
			appVersion
		].join('|');

		const buffer = new TextEncoder().encode(str);
		const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
		return Array.from(new Uint8Array(hashBuffer))
			.map(b => b.toString(16).padStart(2, '0'))
			.join('');
	}

	getOS() {
		const ua = navigator.userAgent;
		if (/Windows NT 10/.test(ua)) return "Windows 10";
		if (/Windows NT 11/.test(ua)) return "Windows 11";
		if (/Macintosh/.test(ua)) return "MacOS";
		if (/Linux/.test(ua)) return "Linux";
		if (/Android/.test(ua)) return "Android";
		if (/iPhone|iPad/.test(ua)) return "iOS";
		return "Unknown";
	}

	getBrowser() {
		const ua = navigator.userAgent;
		if (/Chrome/.test(ua) && !/Edge/.test(ua)) return "Chrome";
		if (/Safari/.test(ua) && !/Chrome/.test(ua)) return "Safari";
		if (/Firefox/.test(ua)) return "Firefox";
		if (/Edge/.test(ua)) return "Edge";
		if (/OPR/.test(ua)) return "Opera";
		return "Unknown";
	}
	// ==============================
	// JS Error Logging - END
	// ==============================

	componentWillUnmount() {
		// Clear global error listeners
		window.removeEventListener("error", this.handleGlobalError);
  		window.removeEventListener("unhandledrejection", this.handlePromiseRejection);
		if (this._onGameLaunchError) {
			window.removeEventListener("message", this._onGameLaunchError);
		}

		// Stop watching <head> for cascade management
		if (this._customStyleObserver) {
			this._customStyleObserver.disconnect();
			this._customStyleObserver = null;
		}

		this.heartbeatStopped = true;
		if (this.channel) this.channel.close();
		clearTimeout(this.heartbeatClaimTimer);
		clearTimeout(this.heartbeatInterval);

		this.tempRecordStopped = true;
		if (this.tempRecordChannel) this.tempRecordChannel.close();
		clearTimeout(this.tempRecordClaimTimer);
		clearTimeout(this.tempRecordInterval);

		if (this._bodyPageClass && document.body) {
			document.body.classList.remove(this._bodyPageClass);
			this._bodyPageClass = null;
		}
	}

	getPageSlug(pathname) {
		const locale = WebUrl.getCurrentLocale();

		// Check if url contains valid locale
		const regex = new RegExp(`^/${locale}(/|$)`);

		if (isValidLocale(locale) && pathname.startsWith(`/${locale}`) && pathname.match(regex)) {
			if (pathname === `/${locale}`) {
				return '/';
			}
			return pathname.replace(`/${locale}`, '');
		} else {
			return pathname.replace(`/${locale}`, '');
		}
	}

	getBodyPageClass() {
		try {
			const pageSlug = this.getPageSlug(window.location.pathname);

			if (pageSlug === '/' || pageSlug === '') {
				return 'page-home';
			}

			const segments = pageSlug.split('/').filter(segment => segment.length > 0);
			const pageName = segments[segments.length - 1];

			return pageName ? `page-${pageName}` : '';
		} catch (e) {
			return '';
		}
	}

	/**
	 * Apply route page-* class via classList so Helmet/SEO re-renders cannot
	 * replace body.className and wipe modal-open / theme-template-* classes.
	 */
	syncBodyPageClass() {
		if (typeof document === 'undefined' || !document.body) return;

		const next = this.getBodyPageClass();
		const prev = this._bodyPageClass;

		if (prev && prev !== next) {
			document.body.classList.remove(prev);
		}
		if (next) {
			document.body.classList.add(next);
		}
		this._bodyPageClass = next || null;
	}

	async fetchSettings() {
		this.setState({ appLoad: true });
		const lang = this.props.i18n.language;
		await this.getSetting(lang);
		this.setState({ appLoad: false, language: lang });
		setTimeout(() => {
			window.dispatchEvent(new CustomEvent("memberGetSettingComplete"));
		}, 0);
	}

	async getMeta(language) {
		// SEO Override System - will override all other SEO settings from other pages
		var pageSlug = this.getPageSlug(window.location.pathname);
		var gameId = '';
		if (pageSlug === '/game-page') {
			var params = new URLSearchParams(window.location.search);
			gameId = params.get("gameId") || '';
		}

		var encodedPageSlug = encodeURIComponent(pageSlug);
		var encodedLanguage = encodeURIComponent(language);
		var encodedGameId = encodeURIComponent(gameId);

		const CACHE_KEY = `seoMeta_${encodedPageSlug}_${encodedLanguage}${encodedGameId ? `_${encodedGameId}` : ""}`;
    	const CACHE_EXPIRY_MS = 1000 * 60 * 60; // 1 hour

		const cached = sessionStorage.getItem(CACHE_KEY);
		
		if (cached) {
			try {
				const parsed = JSON.parse(cached);
				// console.log(JSON.parse(cached))
				if (parsed.expiry && parsed.expiry > Date.now() && parsed.data) {
					this.applySeoData(parsed.data);
					return;
				}
			} catch (e) {
				//console.warn("Failed to parse cached SEO meta:", e);
			}
		}

		let seoRequest = this.seoMetaRequests.get(CACHE_KEY);
		if (!seoRequest) {
			seoRequest = ApiEngine.get(
				`${ApiUrl._API_GET_SEO_META_CONTENT}?slug=${encodedPageSlug}&language=${encodedLanguage}&gameId=${encodedGameId}`
			);
			this.seoMetaRequests.set(CACHE_KEY, seoRequest);
		}

		let responseJson;
		try {
			responseJson = await seoRequest;
		} finally {
			if (this.seoMetaRequests.get(CACHE_KEY) === seoRequest) {
				this.seoMetaRequests.delete(CACHE_KEY);
			}
		}

		var seoManagementFlag = false;

		if (responseJson[ApiKey._API_SUCCESS_KEY] && responseJson[ApiKey._API_DATA_KEY]) {
			// console.log('success', responseJson[ApiKey._API_DATA_KEY])
			var seoData = responseJson[ApiKey._API_DATA_KEY];

			var scriptTagRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/gi;
			var pageName = seoData.pageName;
			var seoTitle = seoData.languageSeoTitle || seoData.seoTitle || '';
			var seoDescription = seoData.languageSeoDescription || seoData.seoDescription || '';
			var seoImage = seoData.languageSeoImage || seoData.seoImage || '';
			var seoKeywords = seoData.languageSeoKeyword || seoData.seoKeyword || seoData.languageSeoKeywords || seoData.seoKeywords || '';
			var customScripts = seoData.languageCustomScripts || seoData.customScripts || '';

			seoManagementFlag = true;

			////get rawScripts
			if (customScripts) {
				var customScriptsJson = JSON.parse(customScripts).html; /// extract the data from html JSON
				var matches = customScriptsJson.match(scriptTagRegex); /// make the html into array
				var contentWithoutScriptTags = null;

				if (matches) {
					var contentWithArrayForTags = matches.map(match => match.match(/<script[^>]*>([\s\S]*?)<\/script>/i)); /////separate each value
					contentWithoutScriptTags = contentWithArrayForTags.map(tags => tags[1]).join(''); ///join both value
				}
			}

			this.setState({
				pageNameOverride: pageName,
				seoTitleOverride: seoTitle,
				seoDescriptionOverride: seoDescription,
				seoImageOverride: seoImage,
				seoKeywordsOverride: seoKeywords,
				rawScripts: contentWithoutScriptTags
			});

			// Store in sessionStorage with expiry
			sessionStorage.setItem(
				CACHE_KEY,
				JSON.stringify({
					data: seoData,
					expiry: Date.now() + CACHE_EXPIRY_MS
				})
			);
		} else {
			// console.log("getMeta error");
		}

		///if seo meta content is empty, show the one in page if got any seo meta

		if (seoManagementFlag == false) {
			if (this.props.appState.seoContent.pageName) {
				// console.log('seoTitle getMeta seoManagementFlag')
				this.setState({ pageName: this.props.appState.seoContent.pageName });
				this.setState({ seoTitle: this.props.appState.seoContent.seoTitle });
				this.setState({ seoDescription: this.props.appState.seoContent.seoDescription });
				this.setState({ seoKeywords: this.props.appState.seoContent.seoKeywords });
			}
		}
	}

	async getBrandSeoSchema() {
		// Fetch brand-specific SEO schema (JSON-LD structured data)
		const CACHE_KEY = 'brandSeoSchema';
		const CACHE_EXPIRY_MS = 1000 * 60 * 60 * 24; // 24 hours (schema doesn't change often)

		const cached = sessionStorage.getItem(CACHE_KEY);
		
		if (cached) {
			try {
				const parsed = JSON.parse(cached);
				if (parsed.expiry && parsed.expiry > Date.now()) {
					this.setState({ brandSeoSchema: parsed.data });
					return;
				}
			} catch (e) {
				//console.warn("Failed to parse cached brand SEO schema:", e);
			}
		}

		try {
			var responseJson = await ApiEngine.get(ApiUrl._API_GET_BRAND_SEO_SCHEMA);

			if (responseJson[ApiKey._API_SUCCESS_KEY] && responseJson[ApiKey._API_DATA_KEY]) {
				var schemaJson = responseJson[ApiKey._API_DATA_KEY];
				
				this.setState({ brandSeoSchema: schemaJson });

				// Store in sessionStorage with expiry
				sessionStorage.setItem(
					CACHE_KEY,
					JSON.stringify({
						data: schemaJson,
						expiry: Date.now() + CACHE_EXPIRY_MS
					})
				);
			}
		} catch (error) {
			//console.warn("Failed to fetch brand SEO schema:", error);
		}
	}

	applySeoData(seoData) {
		if (!seoData) return;
		var scriptTagRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/gi;
		var pageName = seoData.pageName || '';
		var seoTitle = seoData.languageSeoTitle || seoData.seoTitle || '';
		var seoDescription = seoData.languageSeoDescription || seoData.seoDescription || '';
		var seoImage = seoData.languageSeoImage || seoData.seoImage || '';
		var seoKeywords = seoData.languageSeoKeyword || seoData.seoKeyword || seoData.languageSeoKeywords || seoData.seoKeywords || '';
		var customScripts = seoData.languageCustomScripts || seoData.customScripts || '';

		var contentWithoutScriptTags = null;
		if (customScripts) {
			try {
				var customScriptsJson = JSON.parse(customScripts).html;
				var matches = customScriptsJson.match(scriptTagRegex);
				if (matches) {
					var contentWithArrayForTags = matches.map(match =>
						match.match(/<script[^>]*>([\s\S]*?)<\/script>/i)
					);
					contentWithoutScriptTags = contentWithArrayForTags.map(tags => tags[1]).join('');
				}
			} catch (err) {
				//console.warn("Error parsing customScripts JSON from cache", err);
			}
		}

		this.setState({
			pageNameOverride: pageName,
			seoTitleOverride: seoTitle,
			seoDescriptionOverride: seoDescription,
			seoImageOverride: seoImage,
			seoKeywordsOverride: seoKeywords,
			rawScripts: contentWithoutScriptTags
		});
	}

	async initDefaultLanguage() {
		try {
			const responseJson = await ApiEngine.get(ApiUrl._API_GET_COMPANY_LANGUAGE);
			const languages = responseJson?.[ApiKey._API_DATA_KEY];

			if (!responseJson?.[ApiKey._API_SUCCESS_KEY] || !Array.isArray(languages) || !languages.length) {
				return;
			}

			const defaultLanguage = languages.find((language) => language.isDefault) || languages[0];
			const defaultLanguageCode = defaultLanguage?.code;

			if (!defaultLanguageCode) {
				return;
			}

			localStorage.setItem("userSelectedLanguageCode", defaultLanguageCode);
			WebUrl.setCurrentLocale(defaultLanguageCode);
			await this.props.i18n.changeLanguage(defaultLanguageCode);
			await this.props.saveLanguageId(defaultLanguageCode);

			if (!hasValidLocale(this.initialPathname)) {
				const routeLocale = hasValidLocale(window.location.pathname);
				if (routeLocale && routeLocale !== defaultLanguageCode) {
					const nextPathname = window.location.pathname.replace(
						new RegExp(`^/${routeLocale}(/|$)`),
						`/${defaultLanguageCode}$1`
					);

					this.props.history.replace({
						pathname: nextPathname,
						search: window.location.search,
						hash: window.location.hash,
					});
				} else if (!routeLocale && /^\/(game-lobby|game-page)(\/|$)/.test(window.location.pathname)) {
					this.props.history.replace({
						pathname: `/${defaultLanguageCode}${window.location.pathname}`,
						search: window.location.search,
						hash: window.location.hash,
					});
				}
			}
		} catch (error) {
			console.warn("Failed to init default language:", error);
		}
	}

	async getSetting(language) {
		// Pass empty GUID to indicate new client
		const version = localStorage.getItem("webcache_version") || "00000000-0000-0000-0000-000000000000";

		const params = new URLSearchParams({
			LanguageCode: language,
			Version: version
		});

		var responseJson = await ApiEngine.get(
			`${ApiUrl._API_GET_SETTING}?${params.toString()}`
		);


		if (responseJson[ApiKey._API_SUCCESS_KEY]) {

			const normalized = this.normalizeSettings(responseJson[ApiKey._API_DATA_KEY]);

			let cached = localStorage.getItem("webcache_data");

			let currentWebCache = cached ? JSON.parse(cached) : null;

			if(!currentWebCache){
				localStorage.setItem("webcache_version", "");
			}

			if(normalized.useWebCache){
				cached = localStorage.getItem("webcache_data");
				currentWebCache = cached ? JSON.parse(cached) : null;
				if(!currentWebCache){
					localStorage.setItem("webcache_version", "");
				}

			}else{
				localStorage.removeItem("webcache_data");
				localStorage.setItem("webcache_version", "");

			}

			const currentVersion = localStorage.getItem("webcache_version")

			if( !currentVersion || currentVersion != normalized.version){

				if (normalized.useWebCache) {
					localStorage.setItem("webcache_version", normalized.version || "");
					localStorage.setItem("webcache_data", JSON.stringify(responseJson[ApiKey._API_DATA_KEY]));
				}
				
				await this.processSettingResponse(responseJson[ApiKey._API_DATA_KEY]);
				
			}else{
				// var normalizedLocal = this.normalizeSettings(currentWebCache);
				// this.setState({
				// 	useWebCache: normalizedLocal.useWebCache,
				// 	webCacheVersion: normalizedLocal.version,
				// 	webCacheRawEntries: normalizedLocal.rawEntries,
				// });

				
				await this.processSettingResponse(currentWebCache);
			}
			
			
			// Pre-fetch SEO keywords from API (non-blocking)
			getSeoKeywordsAsync({ brandName: responseJson[ApiKey._API_DATA_KEY]?.brandName }).catch(err => {
				console.warn("Failed to pre-fetch SEO keywords:", err);
			});
		}
		window.dispatchEvent(new CustomEvent("memberGetSettingComplete"));
	}

	retrievePlayerCounters(playerCounterSetting, companyTimeZone) {
		const enabledPlayerCounterSetting = Array.isArray(playerCounterSetting)
			? playerCounterSetting.filter((setting) => isPlayerCounterEnabled(setting?.isEnabled))
			: [];

		if (enabledPlayerCounterSetting.length === 0) {
			return [];
		}

		return getPlayerCountersFromSettings(enabledPlayerCounterSetting, companyTimeZone);
	}

	async processSettingResponse(responseJson) {
		// CHRIS 20250306 NOTE: This function updates redux - which causes a duplicate re-render of many components that listen to redux for changes

		// this.setState({ appLoad: true });

		// var responseJson = await ApiEngine.get(
		// 	`${ApiUrl._API_GET_SETTING}?LanguageCode=` + language
		// );

		// Check url params for 'm' (used on Mobile App to permanently hide APK Banner)
		var urlParams = new URLSearchParams(window.location.search);
		if (urlParams.get('m') == true) {
			localStorage.setItem('isMobileApp', 1);

			// Expire after humanity goes extinct
			localStorage.setItem('hideApkBanner', JSON.stringify({ expiry: 99999999999999 }));
		}

		var hideApkBanner = false;
		if (localStorage.getItem('hideApkBanner')) {
			// Parsed hideApkBanner
			var parsedHideApkBanner = JSON.parse(localStorage.getItem('hideApkBanner'));

			// Check if expired
			const expiry = parsedHideApkBanner.expiry;
			if (expiry && expiry > Date.now()) {
				hideApkBanner = true;
			} else {
				localStorage.removeItem('hideApkBanner');
			}
		}
		if (!responseJson) return;

		const version = responseJson.version
		const apiData = responseJson[ApiKey._API_DATA_KEY];
		const normalized = this.normalizeSettings(apiData);

		const settings = normalized.data ?? {};
		const companyUserSettings = settings.companyUserSettings || {};
		const banks = settings.banks || {};
		const dailyCheckIn = settings.dailyCheckIn || {};
		const infoCenter = settings.infoCenter || {};
		const imrewardSettings = settings.imrewardSettings || {};



		// store webcache debug state
		// this.setState({
		// 	useWebCache: normalized.useWebCache,
		// 	webCacheVersion: normalized.version,
		// 	webCacheRawEntries: normalized.rawEntries,
		// });

		// if (normalized.useWebCache) {
		// 	localStorage.setItem("webcache_version", normalized.version || "");
		// }
		// console.log(this.props)
		// if (responseJson[ApiKey._API_SUCCESS_KEY]) 

		{
			var presetAmtData = companyUserSettings.presetAmt || settings.presetAmt || "";
			var chatsphereData = settings.chatsphere || [];
			var quickRegisterData = settings.quickRegister || [];
			var brandNameData = companyUserSettings.brandName || settings.brandName || "";
			var siteTitleData = companyUserSettings.siteTitle || settings.siteTitle || "";
			var siteDescriptionData = companyUserSettings.siteDescription || settings.siteDescription || "";
			var faviconData = companyUserSettings.favicon || settings.favicon || "";
			var companyTimeZone = companyUserSettings.timeZone || settings.timeZone || 8;
			// var userFullNameData = settings.userFullName;
			// var userStatusData = settings.userStatus;
			// var userStatusInStringData = settings.userStatusInString;
			var htmlStyleData = companyUserSettings.htmlStyle || settings.htmlStyle || "";
			var customScriptData = companyUserSettings.customScript || settings.customScript || "";
			var customScriptFooterData = companyUserSettings.customScriptFooter || settings.customScriptFooter || "";

			var currencyData = companyUserSettings.currency || settings.currency;
			var languagesData = settings.languages || [];
			var membershipEnabled = companyUserSettings.membershipEnabled || settings.membershipEnabled;
			var mediasData = settings.medias || [];
			var channelsData = settings.channels || [];
			var currencySymbol = companyUserSettings.currencySymbol || settings.currencySymbol || null;
			var dialingCodes = settings.dialingCodes || [];
			var settingApiComplete = true;
			var promotionLayout = companyUserSettings.promotionLayout ?? settings.promotionLayout;
			var promotionShowCategoryTitle = companyUserSettings.promotionShowCategoryTitle ?? settings.promotionShowCategoryTitle;
			var showPromoThumbnailClaimButton = companyUserSettings.showPromoThumbnailClaimButton ?? settings.showPromoThumbnailClaimButton;
			var isPromoBannerTextVisible = companyUserSettings.isPromoBannerTextVisible ?? settings.isPromoBannerTextVisible;
			var isReferralBonusActive = companyUserSettings.isReferralBonusActive ?? settings.isReferralBonusActive;
			var isReferralRegistrationBonusActive = companyUserSettings.isReferralRegistrationBonusActive ?? settings.isReferralRegistrationBonusActive;
			var otpEnabled = companyUserSettings.otpEnabled ?? settings.otpEnabled;
			var eWalletOTPEnabled = companyUserSettings.eWalletOTPEnabled ?? settings.eWalletOTPEnabled;
			var captchaEnabled = companyUserSettings.captchaEnabled ?? settings.captchaEnabled;
			var priorityModalTypeId = companyUserSettings.priorityModalTypeId ?? settings.priorityModalTypeId;
			var dashboardComponent = settings.dashboardComponent; // Not in use, can remove later, we currently use dashboardResult instead
			var isNormalDepositEnable = banks.isNormalDepositEnable ?? settings.isNormalDepositEnable;
			var isNormalWithdrawalEnable = banks.isNormalWithdrawalEnable ?? settings.isNormalWithdrawalEnable;
			var isCryptoWithdrawalEnabled = settings.flags?.isCryptoWithdrawalEnabled ?? settings.isCryptoWithdrawalEnabled;
			var musicPlayerEnabled = companyUserSettings.musicPlayerEnabled ?? settings.musicPlayerEnabled;
			var musicTrackList = settings.musicTrackList;
			var isEWalletActive = settings.flags?.isEWalletActive ?? settings.isEWalletActive;
			var isBankTransferActive = settings.flags?.isBankTransferActive ?? settings.isBankTransferActive;
			var isReferralCommissionManual = companyUserSettings.isReferralCommissionManual ?? settings.isReferralCommissionManual;
			var isRebateManual = companyUserSettings.isRebateManual ?? settings.isRebateManual;
			var availableProductCategories = settings.availableProductCategories || [];
			var isGameLobbyRequired = companyUserSettings.isGameLobbyRequired ?? settings.isGameLobbyRequired;
			var bannerAPK = hideApkBanner ? "" : (settings.bannerAPK ?? "");
			var homepageBanner = settings.homepageBanner;

			var isLoginAttemptBlockingEnabled = companyUserSettings.isLoginAttemptBlockingEnabled ?? settings.isLoginAttemptBlockingEnabled;
			var isHotGameEnabled = settings.hotGames?.isHotGameEnabled ?? false;
			var hotGames = settings.hotGames?.gameList || [];
			var productHotNewGames = settings.productHotNewGames || { hotGames: [], newGames: [] };
			var affiliateLink = companyUserSettings.affiliateLink ?? settings.affiliateLink;
			var isCasinoLobbyEnabled = companyUserSettings.isCasinoLobbyEnabled ?? settings.isCasinoLobbyEnabled;
			var isEZUsernameEnabled = companyUserSettings.isEZUsernameEnabled ?? settings.isEZUsernameEnabled;
			var infoCenterEnabled = infoCenter.infoCenterEnabled || settings.infoCenterEnabled;
			var forceMemberFullname = companyUserSettings.forceMemberFullname ?? settings.forceMemberFullname;
			var affiliateEnabled = companyUserSettings.affiliateEnabled ?? settings.affiliateEnabled; // Added from john's commit (368905b6484fa98046a2d961162656e830943908)
			var affiliateNewTabEnabled = companyUserSettings.affiliateNewTabEnabled ?? settings.affiliateNewTabEnabled;
			var isMultiWithdrawalBank = companyUserSettings.isMultiWithdrawalBank ?? settings.isMultiWithdrawalBank;
			var maxWithdrawalBankAccounts = companyUserSettings.maxWithdrawalBankAccounts ?? settings.maxWithdrawalBankAccounts ?? 0;
			var depositFlow = companyUserSettings.depositFlow ?? settings.depositFlow;
			var downlineContact = companyUserSettings.downlineContact ?? settings.downlineContact;
			var isRTPRequired = companyUserSettings.isRTPRequired ?? settings.isRTPRequired;
			var oneWallet = companyUserSettings.oneWallet ?? settings.oneWallet;

			var availableProviders = settings.availableProviders;
			var floatingChat = settings.floatingChat;
			var spinWheelSetting = imrewardSettings.spinWheelSetting || settings.spinWheelSetting;
			var dashboardResult = settings.dashboardResult;
			var infoCenterResult = infoCenter.infoCenterResult || settings.infoCenter?.infoCenterResult;
			var dailyCheckInStatus = dailyCheckIn.dailyCheckInStatus || settings.dailyCheckIn?.dailyCheckInStatus;
			var marqueeResult = settings.marquee ?? settings.marqueeResult;
			var rewardAdvancedSetting = imrewardSettings.rewardAdvancedSetting || settings.rewardAdvancedSetting;
			var requireBankAccountKYC = companyUserSettings.requireBankAccountKYC ?? settings.requireBankAccountKYC;
			var isRegistrationSuccessCountdownEnabled =
				companyUserSettings.isRegistrationSuccessCountdownEnabled ??
				settings.isRegistrationSuccessCountdownEnabled ??
				false;
			var inactiveDownlineAmount = companyUserSettings.inactiveDownlineAmount ?? settings.inactiveDownlineAmount;	
			var settingVersion = normalized.version || version;
			var membershipEnabled = companyUserSettings.membershipEnabled ?? settings.membershipEnabled;
			var isHotProviderEnabled = settings.hotProviders?.isHotProviderEnabled ?? false;
			var hotProviders = settings.hotProviders?.providerList || [];
            var playerCounterSetting = normalizePlayerCounterSettings(settings.playerCounterSetting ?? [], companyTimeZone);
			var fakeTransactionSetting = readFakeTransactionCache(settings.fakeTransactionSetting);

			var playerCounters = this.retrievePlayerCounters(playerCounterSetting, companyTimeZone);
			var leaderboard = settings?.leaderboard || [];

			var requireMemberEmailOnWithdrawal = companyUserSettings.requireMemberEmailOnWithdrawal ?? settings.requireMemberEmailOnWithdrawal;
			var showDepositBankBranchCode = companyUserSettings.showDepositBankBranchCode ?? settings.showDepositBankBranchCode ?? false;
			var newGameDurationDays = Number(companyUserSettings.newGameDurationDays ?? settings.newGameDurationDays);
			if (!Number.isFinite(newGameDurationDays)) {
				newGameDurationDays = 90;
			} else if (newGameDurationDays < 0) {
				newGameDurationDays = 0;
			}

			// Apply per-company translation overrides from WebCache (delta only — untouched keys stay from bundle)
			const translationOverrides = settings.memberAppTranslations;
			if (translationOverrides && typeof translationOverrides === "object" && Object.keys(translationOverrides).length > 0) {
				const currentLocale = this.props.i18n.language;
				this.props.i18n.addResourceBundle(currentLocale, "common", translationOverrides, true, true);
			}

		if (htmlStyleData && htmlStyleData != "") {
			let styleEl = document.getElementById("custom-style");
			if (!styleEl) {
				styleEl = document.createElement("style");
				styleEl.id = "custom-style";
			}
			styleEl.textContent = htmlStyleData;
			// Always re-append to end of <head> so custom-style is the last
			// stylesheet in the cascade — overriding all bundled/linked CSS files.
			document.head.appendChild(styleEl);
		}


			if (customScriptData && customScriptData !== "") {
				this.injectCustomScripts(customScriptData);
				// const existingScript = document.getElementById("custom-script");
				// if (!existingScript) {
				// 	const scriptElement = document.createElement("script");
				// 	scriptElement.id = "custom-script";
				// 	// Wrap customScriptData in try catch
				// 	scriptElement.innerHTML = `
				// 		try {
				// 			`+customScriptData+`
				// 		} catch(e) {
				// 			console.error('Error in executing custom script:', e)
				// 		}`;

				// 	document.head.appendChild(scriptElement);
				// }
			}

			if (customScriptFooterData && customScriptFooterData !== "") {
				// const existingScript = document.getElementById("custom-script-footer");
				// if (!existingScript) {
				// 	const scriptElement = document.createElement("script");
				// 	scriptElement.id = "custom-script-footer";
				// 	scriptElement.innerHTML = customScriptFooterData;
				// 	document.body.appendChild(scriptElement);
				// }

				this.injectCustomFooterScripts(customScriptFooterData);
			}

			var referralGtmMap = companyUserSettings.referralGtmMap || settings.referralGtmMap || {};
			var referralGtmId = lookupGtmId(referralGtmMap, resolveReferralCode());
			if (referralGtmId) {
				injectReferralGtm(referralGtmId);
			}

			// this.setState({ appLoad: false });

			var chatsphere = [];
			const _APPEND_REGISTER_WHATSAPP_URL = "?text=register%20";
			const _APPEND_REGISTER_TELEGRAM_URL = "?start=";

			chatsphereData.forEach((x) => {
				chatsphere.push({
					usage: x.usage,
					url:
						x.usage == "Whatsapp"
							? "https://wa.me/" + x.phoneNumber + _APPEND_REGISTER_WHATSAPP_URL
							: x.usage == "Telegram"
								? "https://t.me/" + x.phoneNumber + _APPEND_REGISTER_TELEGRAM_URL
								: "",
					image: x.image,
				});
			});

			chatsphereData = chatsphere;

			const { setAppSetting } = this.props;
			setAppSetting(
				brandNameData,
				presetAmtData,
				currencyData,
				mediasData,
				channelsData,
				htmlStyleData,
				chatsphereData,
				quickRegisterData,
				languagesData,
				membershipEnabled,
				currencySymbol,
				dialingCodes,
				settingApiComplete,
				promotionLayout,
				promotionShowCategoryTitle,
				showPromoThumbnailClaimButton,
				isPromoBannerTextVisible,
				isReferralBonusActive,
				isReferralRegistrationBonusActive,
				otpEnabled,
				eWalletOTPEnabled,
				captchaEnabled,
				priorityModalTypeId,
				dashboardComponent,
				isNormalDepositEnable,
				isNormalWithdrawalEnable,
				isCryptoWithdrawalEnabled,
				musicPlayerEnabled,
				musicTrackList,
				isEWalletActive,
				isBankTransferActive,
				isReferralCommissionManual,
				isRebateManual,
				availableProductCategories,
				isGameLobbyRequired,
				companyTimeZone,
				bannerAPK,
				homepageBanner,
				//floatingChat,
				isLoginAttemptBlockingEnabled,
				isHotGameEnabled,
				hotGames,
				affiliateLink,
				isCasinoLobbyEnabled,
				isEZUsernameEnabled,
				infoCenterEnabled,
				forceMemberFullname,
				affiliateEnabled,
				affiliateNewTabEnabled,
				isMultiWithdrawalBank,
				maxWithdrawalBankAccounts,
				depositFlow,
				downlineContact,
				isRTPRequired,
				oneWallet,
				availableProviders,
				floatingChat,
				spinWheelSetting,
				dashboardResult,
				infoCenterResult,
				dailyCheckInStatus,
				marqueeResult,
				rewardAdvancedSetting,
				requireBankAccountKYC,
				isRegistrationSuccessCountdownEnabled,
				inactiveDownlineAmount,
				settingVersion,
				isHotProviderEnabled,
				hotProviders,
				playerCounterSetting,
				playerCounters,
				requireMemberEmailOnWithdrawal,
				showDepositBankBranchCode,
				newGameDurationDays,
				leaderboard,
				productHotNewGames,
				fakeTransactionSetting
			);
			//SEO
			//{
			var data = [] // responseJson[ApiKey._API_DATA_KEY].data.seo;

			var contentLength = data.length;
			var list = [];
			var newData = [];
			var newList = [];
			for (var x = 0; x < contentLength; x++) {
				var content = JSON.parse(data[x]["content"]);
				var contentLength1 = Object.keys(content).length;
				for (var i = 0; i < contentLength1; i++) {
					var jsonObj = JSON.parse(content["parameter_" + (i + 1)]);
					newData.push({
						name: "PARAMETER " + (i + 1),
						metaType: jsonObj["metaType"],
						content: jsonObj["content"],
					});
				}
				newList = {
					metaType: data[x]["metaDataType"],
					data: newData,
				};
				newData = [];
				list.push(newList);
			}
			var titleList = [];
			var meta = [];
			var link = [];
			var script = [];
			var noscript = [];
			var base = [];
			var title = "";

			for (var i = 0; i < list.length; i++) {
				if (list[i].metaType == "Meta") {
					for (var x = 0; x < list[i].data.length; x++) {
						var content = list[i].data[x].content;
						try {
							var trimmedContent = content.trim();
							var jsonObject = JSON.parse(trimmedContent);

							meta.push({
								page: list[i].data[x].metaType,
								content: jsonObject,
							});
						} catch (error) {
							console.error("Error parsing JSON:", error);
							console.error("Invalid JSON content:", content);
						}
					}
				} else if (list[i].metaType == "Title") {
					for (var x = 0; x < list[i].data.length; x++) {
						titleList.push({
							page: list[i].data[x].metaType,
							content: list[i].data[x].content,
						});
					}
				} else if (list[i].metaType == "Link") {
					for (var x = 0; x < list[i].data.length; x++) {
						var content = list[i].data[x].content;
						var jsonObject = JSON.parse(content);
						link.push({
							page: list[i].data[x].metaType,
							content: jsonObject,
						});
					}
				} else if (list[i].metaType == "script") {
					for (var x = 0; x < list[i].data.length; x++) {
						var page = list[i].data[x].metaType;
						var content = list[i].data[x].content;

						try {
							var jsonObject = JSON.parse(content);
							var code = jsonObject.code.replaceAll("'", `"`);
							jsonObject.code = code;
							script.push({
								page: page,
								content: jsonObject,
							});
						} catch (e) {
							// console.error(`Error parsing JSON for page: ${page}`, e);
							// console.log("Content received:", content);
							// Handle the error appropriately, e.g., skip this item, use a default value, etc.
						}
					}
				} else if (list[i].metaType == "noscript") {
					for (var x = 0; x < list[i].data.length; x++) {
						var page = list[i].data[x].metaType;
						var content = list[i].data[x].content;
						var jsonObject = JSON.parse(content);
						noscript.push({
							page: page,
							content: jsonObject,
						});
					}
				} else if (list[i].metaType == "Base") {
					for (var x = 0; x < list[i].data.length; x++) {
						var page = list[i].data[x].metaType;
						var content = list[i].data[x].content;
						var jsonObject = JSON.parse(content);
						base.push({
							page: page,
							content: jsonObject,
						});
					}
				}
			}

			var scriptList = [];
			var metaList = [];
			var linkList = [];
			var noscriptList = [];
			var baseList = [];

			if (titleList.length > 0) {
				titleList
					.filter((title) => title.page == window.location.pathname)
					.map((content) => {
						if (!stringIsNullOrEmpty(content)) {
							title = content.content;
						}
					});

				if (stringIsNullOrEmpty(title)) {
					titleList
						.filter((title) => title.page == "*")
						.map((contentAll) => {
							title = contentAll.content;
						});
				}
			}

			if (script.length > 0) {
				script
					.filter(
						(scrips) =>
							scrips.page == window.location.pathname || scrips.page == "*"
					)
					.map((content) => {
						if (!stringIsNullOrEmpty(content)) {
							scriptList.push(content.content);
						}
					});
			}

			if (meta.length > 0) {
				meta
					.filter(
						(metas) =>
							metas.page == "*" || metas.page == window.location.pathname
					)
					.map((content) => {
						if (!stringIsNullOrEmpty(content)) {
							metaList.push(content.content);
						}
					});
				var list = [];
				var listPage = [];
				if (metaList.length > 0) {
					var filterList = meta.filter(function (obj) {
						if (obj.content.name === "description") {
							list.push(obj.content);
							listPage.push(obj.page);
							return obj.content;
						}
					});
					var i = 0;
					var x = 0;
					while (i < metaList.length) {
						if (metaList[i] === list[x]) {
							metaList.splice(i, 1);
							x++;
						} else {
							++i;
						}
					}
				}

				listPage.includes(window.location.pathname)
					? filterList
						.filter((a) => a.page == window.location.pathname)
						.map((content) => {
							metaList.push(content.content);
						})
					: filterList
						.filter((a) => a.page == "*")
						.map((content) => {
							metaList.push(content.content);
						});
			}

			if (link.length > 0) {
				link
					.filter(
						(links) =>
							links.page == window.location.pathname || links.page == "*"
					)
					.map((content) => {
						if (!stringIsNullOrEmpty(content)) {
							linkList.push(content.content);
						}
					});
			}

			if (noscript.length > 0) {
				noscript
					.filter(
						(noscripts) =>
							noscripts.page == window.location.pathname ||
							noscripts.page == "*"
					)
					.map((content) => {
						if (!stringIsNullOrEmpty(content)) {
							noscriptList.push(content.content);
						}
					});
			}

			if (base.length > 0) {
				base
					.filter(
						(bases) =>
							bases.page == window.location.pathname || bases.page == "*"
					)
					.map((content) => {
						if (!stringIsNullOrEmpty(content)) {
							baseList.push(content.content);
						}
					});
			}

			this.setState({ baseList: baseList });
			this.setState({ brandName: brandNameData });
			this.setState({ noscriptList: noscriptList });
			this.setState({ scriptList: scriptList });
			this.setState({ linkList: linkList });
			this.setState({ title: siteTitleData });
			this.setState({ description: siteDescriptionData });
			this.setState({ metaList: metaList });
			this.setState({ seo: list });
			this.setState({ favicon: faviconData });
			//}
		}
	}

	injectCustomScripts(customScriptData) {
		const wrapper = document.createElement("div");
		wrapper.innerHTML = customScriptData;

		Array.from(wrapper.childNodes).forEach(node => {
			if (node.tagName === "SCRIPT") {
				const scriptId = node.id || `custom-script-${this.generateHash(node.src || node.textContent)}`;
				if (document.getElementById(scriptId)) return;

				const script = document.createElement("script");
				script.id = scriptId;
				if (node.src) {
					script.src = node.src;
					script.async = node.async;
				} else {
					script.textContent = node.textContent;
				}
				document.head.appendChild(script);
			} else if (node.tagName === "NOSCRIPT") {
				const noscriptId = node.id || `custom-noscript-${this.generateHash(node.textContent)}`;
				if (document.getElementById(noscriptId)) return;

				node.id = noscriptId;
				document.head.appendChild(node);
			}
		});
	}

	injectCustomFooterScripts(customScriptFooterData) {
		const wrapper = document.createElement("div");
		wrapper.innerHTML = customScriptFooterData;

		Array.from(wrapper.childNodes).forEach(node => {
			if (node.tagName === "SCRIPT") {
				const scriptId = node.id || `custom-footer-script-${this.generateHash(node.src || node.textContent)}`;
				if (document.getElementById(scriptId)) return;

				const script = document.createElement("script");
				script.id = scriptId;
				if (node.src) {
					script.src = node.src;
					script.async = node.async;
				} else {
					script.textContent = node.textContent;
				}
				document.body.appendChild(script);
			} else if (node.tagName === "NOSCRIPT") {
				const noscriptId = node.id || `custom-footer-noscript-${this.generateHash(node.textContent)}`;
				if (document.getElementById(noscriptId)) return;

				node.id = noscriptId;
				document.body.appendChild(node);
			}
		});
	}

	generateHash(str) {
		let hash = 0;
		for (let i = 0; i < str.length; i++) {
			const char = str.charCodeAt(i);
			hash = ((hash << 5) - hash) + char;
			hash = hash & hash; // Convert to 32bit integer
		}
		return Math.abs(hash).toString(36);
	}

	render() {
		const {
			seo,
			metaList,
			brandName,
			title,
			description,
			favicon,
			linkList,
			scriptList,
			noscriptList,
			location,
			language,
			seoTitle,
			seoDescription,
			seoImage,
			seoKeywords,
			seoTitleOverride,
			seoDescriptionOverride,
			seoImageOverride,
			seoKeywordsOverride,
			rawScripts,
			brandSeoSchema,
			appLoad,
		} = this.state;

		const resolvedTitle = (seoTitleOverride && seoTitleOverride.length)
			? seoTitleOverride
			: (seoTitle && seoTitle.length ? seoTitle : title);

		const resolvedDescription = (seoDescriptionOverride && seoDescriptionOverride.length)
			? seoDescriptionOverride
			: (seoDescription && seoDescription.length ? seoDescription : description);

		const pageSeoKeywords = this.props.appState.seoContent?.seoKeywords;
		const keywords = getSeoKeywords({
			brandName,
			title: resolvedTitle,
			description: resolvedDescription
		});
		const resolvedKeywords = (seoKeywordsOverride && seoKeywordsOverride.length)
			? seoKeywordsOverride
			: (pageSeoKeywords && pageSeoKeywords.length)
			? pageSeoKeywords
			: (seoKeywords && seoKeywords.length)
				? seoKeywords
			: keywords;

		if (this.state.errorInfo) {
			return (
				<div className="error" style={{ padding: "20px" }}>
					<img
						src={require("./assets/img/error.png")}
						style={{
							maxWidth: "100px",
							objectFit: "contain",
							marginLeft: "auto",
							marginRight: "auto",
						}}
					/>
					<h3>Something went wrong, please contact admin for help</h3>
					<div className="m-b-30">{window.navigator.userAgent}</div>
				</div>
			);
		} else {
			return (
				<PageSettings.Provider value={this.state} className="template-3">
					{/* <Helmet title={title} meta={metaList} link={linkList} /> */}


					{/* Set dynamic metas - START */}
					{/* seoTitle - Always render with fallback to prevent React Helmet from removing server-rendered tags */}
					<Helmet>
						<title>{resolvedTitle}</title>
						<meta property="og:title" content={resolvedTitle} />
						<meta property="twitter:title" content={resolvedTitle} />
					</Helmet>

					{/* URL - Always render */}
					<Helmet>
						<link rel="canonical" href={location} />
						<meta property="og:url" content={location} />
						<meta property="twitter:url" content={location} />
					</Helmet>

					{/* seoDescriptions - Always render with fallback to prevent React Helmet from removing server-rendered tags */}
					<Helmet>
						<meta name="description" content={resolvedDescription} />
						<meta name="keywords" content={resolvedKeywords} key="meta-keywords" />
						<meta property="og:description" content={resolvedDescription} />
						<meta property="twitter:description" content={resolvedDescription} />
					</Helmet>


					{/* seoImages - Only render if we have an image to show */}
					{(seoImageOverride || seoImage) && (
						<Helmet>
							<meta property="og:image" content={seoImageOverride || seoImage} />
							<meta property="og:image:width" content="1200" />
							<meta property="og:image:height" content="630" />
							<meta name="twitter:card" content="summary_large_image" />
							<meta property="twitter:image" content={seoImageOverride || seoImage} />
						</Helmet>
					)}

					{/* Brand-specific SEO Schema (JSON-LD) */}
					{brandSeoSchema && (
						<Helmet>
							<script type="application/ld+json">
								{brandSeoSchema}
							</script>
						</Helmet>
					)}

					{/* Custom Scripts */}
					<Helmet>
						{rawScripts && rawScripts.length && (
							<script key={seoTitle} type="text/javascript">
								{rawScripts}
							</script>
						)}
					</Helmet>


					{scriptList &&
						scriptList.length > 0 &&
						scriptList.map(({ code, type, id, src }, index) => {
							// Create an object to hold the props
							const props = {};

							// Conditionally add props to the object
							if (src !== undefined) {
								props.src = src;
							}
							if (id !== undefined) {
								props.id = id;
							}
							if (type !== undefined) {
								props.type = type;
							}

							return (
								<Helmet key={index}>
									<script {...props}>{code}</script>
								</Helmet>
							);
						})}

					{noscriptList &&
						noscriptList.length > 0 &&
						noscriptList.map(({ code }, index) => (
							<Helmet key={index}>
								<noscript>{code}</noscript>
							</Helmet>
						))}

					{/* Set dynamic metas - END */}

					{/* Global SEO/a11y: ensure there is at least one <h1> in the DOM for audits/crawlers */}
					{this.state.showSeoH1 && (
						<h1
							id="seo-h1"
							className="brand-h1"
						>
							{this.getSeoH1Text()}
						</h1>
					)}

					{(this.props.appState.isBusy || !this.props.authState.loginStateInitialized) &&
						<div className="loader-line"></div>
					}

					<LoadingOverlay
						active={this.props.appState.isBusyLoading}
						styles={{
							overlay: (base) => ({
								...base,
								zIndex: "10000",
								position: "fixed",
							}),
						}}
						className={classNames("loading-overlay")}
					>
						{/* <img src={require("../../../assets/img/loading.gif")} />
						*/}
						<Spinner
							className="dynamic-table-spinner"
							animation="border"
							role="status"
							size="sm"
							style={{
								verticalAlign: "middle",
								width: "2rem",
								height: "2rem",
								color: "#fff"
							}}
						></Spinner>
						{/* <p>{this.props.appState.message}</p> */}
					</LoadingOverlay>

					{!isObjectEmpty(this.props.appState.alert) && (
						<div className="sweet-alert-container t3-sweet-alert-container">
							<SweetAlert
								{...this.props.appState.alert}
								style={
									this.props.appState.member.id != undefined
										? {
											backgroundColor: "#05102F",
											borderColor: "white !important",
											opacity: 0.95,
											color: "white",
										}
										: ""
								}
							>
						     <div
                                dangerouslySetInnerHTML={{
                                    __html:
                                        this.props.appState.alert.html ||
                                        this.props.appState.alert.content?.replace(/\n/g, "<br/>")
                                }}
                            />
							</SweetAlert>
						</div>
					)}
					<ThemePreviewBar />
					{this.props.authState.loginStateInitialized && (
						<PromoExpiryPoll />
					)}

					{this.props.authState.loginStateInitialized && !appLoad && (
						<>
							<div
								ref={this.scrollRef}
								className="fade page-sidebar-fixed show page-container page-content-full-height"
								style={{
									minHeight: "100vh",
									height: "100%",
									userSelect: "none",
									WebkitTouchCallout: "none",
									WebkitUserSelect: "none",
									MozUserSelect: "none",
									msUserSelect: "none",
								}}
							>
								<div
									onClick={() => {
										if (this.state.pageSidebarToggled) {
											this.toggleMobileSideba();
										}
									}}
								>
									{this.state.pageContent && (
										<SchemaLoader>
											<Content />
										</SchemaLoader>
									)}
								</div>
							</div>
						</>
					)}
				</PageSettings.Provider>
			);
		}
	}
}

const mapStateToProps = (state) => ({
	...state,
});

const mapDispatchToProps = {
	updateLoginUser,
	resetLogin,
	performLogout,
	heartBeat,
	handleHeartbeatResponse,
	setAppSetting,
	setDepositModal,
	setDownlineModal,
	setShareReferralModal,
	setGameLobbyModal,
	setMyProfileModal,
	setSpinWheelListModal,
	setSpinWheelReportModal,
	setReportOverviewModal,
	setGameIframeModal,
	setCompleteInfoModal,
	setDailyCheckinModal,
	setReferralBonusModal,
	setMusicPlayerModal,
	triggerParallelLoginRedirect,
	setBusy,
	setIdle,
	saveLanguageId,
	setRegisterSuccessModal,
	setShowAnnouncementModal
  };

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(
		withTranslation()(App)
	)
);
